(function ($, document, window) {
    'use strict';

    $(function () {
        const $carousel = $('.js-image-card-collection');
        const draggingClass = 'is-dragging';

        /**
         * Initialises the carousel layout.
         * Provides drag functionality and auto-scrolling.
         * 
         * @param {jQuery} $carousel - The carousel element. 
         */
        function handleLayout($carousel) {
            const $track = $carousel.find('.js-image-card-track');
            const $wrappers = $carousel.find('.js-image-card-wrapper');

            /**
             * Animation state
             */
            let animationId = null;
            let xPercent = 0;
            const baseSpeed = 0.03;

            /**
             * Drag state
             */
            let isDragging = false;
            let hasDragged = false;
            let startX = 0;
            let dragOffset = 0;
            let velocity = 0;
            let lastX = 0;
            let lastTime = Date.now();
            const dragThreshold = 5;

            /**
             * Main animation loop.
             * Handles momentum decay, and looping.
             */
            function animate() {
                // Apply momentum decay after drag is released.
                if (!isDragging && Math.abs(velocity) > 0.001) {
                    xPercent += velocity;
                    velocity *= 0.95; // Friction
                }
                // Auto-scroll only when not dragging, and no momentum
                else if (!isDragging) {
                    xPercent -= baseSpeed;
                }

                // Reset the position for the loop effect.
                // When the first wrapper is fully off screen, reset to show it again.
                if (xPercent < -100) {
                    xPercent = 0;
                } else if (xPercent > 0) {
                    xPercent = -100;
                }

                // Apply transform to both wrappers.
                // During drag, add the offset and normalize so the loop is visible while dragging.
                let finalPosition = isDragging
                    ? xPercent + dragOffset
                    : xPercent;

                if (isDragging) {
                    while (finalPosition <= -100) {
                        finalPosition += 100;
                    }
                    while (finalPosition > 0) {
                        finalPosition -= 100;
                    }
                }

                $wrappers.each(function () {
                    $(this).css('transform', `translateX(${finalPosition}%)`);
                });

                animationId = requestAnimationFrame(animate);
            }

            /**
             * Handles the start of a drag interaction.
             * 
             * @param {Event} e- The mousedown or touchstart event.
             */
            function handlePointerDown(e) {
                if ($(e.target).closest('.js-image-card-link').length) {
                    e.preventDefault();
                }

                isDragging = true;
                hasDragged = false;

                startX = e.type.includes('touch')
                    ? e.touches[0].clientX
                    : e.clientX;
                lastX = startX;
                lastTime = Date.now();
                velocity = 0;
                dragOffset = 0;
            }

            function handlePointerMove(e) {
                if (!isDragging) return;

                const clientX = e.type.includes('touch')
                    ? e.touches[0].clientX
                    : e.clientX;
                const diff = clientX - startX;

                // Check if the drag has moved beyond the threshold.
                if (Math.abs(diff) > dragThreshold) {
                    hasDragged = true;
                    e.preventDefault();

                    if (!$carousel.hasClass(draggingClass)) {
                        $carousel.addClass(draggingClass);
                    }
                }

                // Don't apply drag offset until threshold is met.
                if (!hasDragged) return;

                // Convert pixel difference to percentage.
                const wrapperWidth = $wrappers.first().outerWidth();
                dragOffset = (diff / wrapperWidth) * 100;

                // Calculate velocity for momentum effect on release.
                const now = Date.now();
                const timeDiff = now - lastTime;

                if (timeDiff > 0) {
                    const pixelVelocity = (clientX - lastX) / timeDiff;
                    // Convert to percentage per frame.
                    velocity = (pixelVelocity / wrapperWidth) * 100 * 16;
                }

                lastX = clientX;
                lastTime = now;
            }

            /**
             * Handles the end of a drag interaction.
             * Merges drag offset into main position and allows momentum to continue.
             * 
             * @param {Event} e - The mouseup or touchend event.
             */
            function handlePointerUp(e) {
                if (!isDragging) return;

                isDragging = false;
                $carousel.removeClass(draggingClass);

                // Merge the drag offset into the main xPercent position.
                xPercent += dragOffset;
                dragOffset = 0;

                // Normalise the position to keep within -100 to 0 range.
                while (xPercent <= -100) {
                    xPercent += 100;
                }

                while (xPercent > 0) {
                    xPercent -= 100;
                }

                // Velocity will naturally decay in the animate() loop.
                // Nothing else to do here.
            }

            // Prevent link clicks when dragging
            $carousel.on('click', '.js-image-card-link', function (e) {
                if (hasDragged) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });

            // Prevent images or links from being dragged
            $carousel.on('dragstart', '.js-image-card-image, .js-image-card-link', function (e) {
                e.preventDefault();
            });

            $track.on('mousedown', handlePointerDown);
            $track.on('touchstart', handlePointerDown);

            $(document).on('mousemove', handlePointerMove);
            $(document).on('touchmove', handlePointerMove, { passive: false });

            $(document).on('mouseup', handlePointerUp);
            $(document).on('touchend', handlePointerUp);

            animate();
        }

        $carousel.each(function () {
            handleLayout($(this));
        });
    });
})(jQuery, document, window);
